import { useAuth as useAuthFromContext } from '../contexts/AuthContext';

/**
 * Hook to access authentication context
 * This is a compatibility hook that uses the consolidated AuthContext
 */
const useAuth = () => {
  // Use the useAuth implementation from contexts/AuthContext
  return useAuthFromContext();
};

export default useAuth; 